import Vue from 'vue'
import moment from 'moment'
const filters = {
  formatGrade (val) {
    let value = ''
    let types = [
      { v: 'junior', t: '初级教练' },
      { v: 'medium', t: '中级教练' },
      { v: 'senior', t: '高级教练' },
      { v: 'international', t: '国际教练' }
    ]
    for (let [, el] of types.entries()) {
      if (Object.is(val, el.v)) {
        value = el.t
      }
    }
    return value
  },
  formatActivity (val) {
    let value = ''
    let types = [
      { v: '1', t: '进行中' },
      { v: '2', t: '报名截止' },
      { v: '3', t: '报名中' },
      { v: '4', t: '已报满' },
      { v: '5', t: '已结束' }
    ]
    for (let [, el] of types.entries()) {
      if (Object.is(val, el.v)) {
        value = el.t
      }
    }
    return value
  },
  formatSignType (val, num, t) {
    if (val === '1' && t === '元') {
      return num.toFixed(2) + t
    } else if (val === '1' || val === '金额' || val === '元' || val === '免费') {
      return '￥' + num.toFixed(2)
    } else if (val === '2' || val === '积分') {
      return num + ' 积分'
    } else if (val === '3' || val === '基础课节') {
      return num.toFixed(2) + ' 基础课节'
    } else {
      return ''
    }
  },
  formatTime (val) {
    let day = moment().format('YYYY-MM-DD')
    let time = moment(day)
    if (moment().diff(moment(val)) < 1000 * 60 * 10 && moment().diff(moment(val)) > 0) {
      // 当前时间10分钟之前
      return '刚刚'
    } else if (time.diff(moment(val)) < 0) {
      // 今天
      return moment(val).format('HH:mm')
    } else if (time.diff(moment(val)) < 1000 * 60 * 60 * 24) {
      // 昨天
      return '昨天' + moment(val).format('HH:mm')
    } else if (time.diff(moment(val)) < 1000 * 60 * 60 * 24 * 2) {
      // 前天
      return '前天' + moment(val).format('HH:mm')
    } else {
      return moment(val).format('MM/DD HH:mm')
    }
  },
  formatOrderType (val) {
    if (val === 'curse' || val === '课' || val === '期课') {
      return '课程票'
    } else if (val === 'courseExperience' || val === '体验课') {
      return '体验课'
    } else if (val === '时段票实例') {
      return '时段票'
    } else if (val === '单次票实例') {
      return '单次票'
    } else if (val === '练习票实例') {
      return '练习票'
    } else if (val === '陪同票实例') {
      return '陪同票'
    } else if (val === '活动') {
      return '活动'
    } else if (val === '课程卡') {
      return '课程卡'
    } else {
      return '商品订单'
    }
  },
  formatDate (val) {
    return val ? moment(val).format('YYYY.MM.DD') : ''
  },
  formatCouponStatus (val) {
    let value = ''
    let types = [
      { v: 'unused', t: '可使用' },
      { v: 'used', t: '已使用' },
      { v: 'expired', t: '已过期' },
      { v: 'invalid', t: '已失效' }
    ]
    for (let [, el] of types.entries()) {
      if (Object.is(val, el.v)) {
        value = el.t
      }
    }
    return value
  }
}
for (let key in filters) {
  Vue.filter(key, filters[key])
}



// WEBPACK FOOTER //
// ./src/common/js/filter.js